import {getCookie,setCookie} from "./auth";
import languageArea from './languageAreaCode'
let languageList = languageArea.map(item => item.language)
let currentLanguage = getCookie('language')
if(!currentLanguage){
  let currentlang = window.navigator.language.split('-')[0]
  let data = languageList.find(item=>item.split('-')[0] === currentlang ) || 'en'
  if(data == 'zh'){
    setCookie('language','zh-TC')
  }else{
    setCookie('language',data.split('-')[0])
  }
}



// WEBPACK FOOTER //
// ./src/utils/getCurrentLanguage.js